import React from "react";

export const rentalAgreementStatusMessage: React.ReactElement = (
  <p>
    After submitting your application{" "}
    <strong>we&apos;ll ask you for a copy of your rental agreement</strong> to
    verify your living situation
  </p>
);

export const ContactLabels = {
  PARENTS: {
    value: "parent",
    name: "Parent name",
    number: "Parent phone number",
  },
  BOARDING: {
    value: "property manager",
    name: "Property owner/manager name",
    number: "Property owner/manager phone number",
  },
  EMPLOYER: {
    value: "employer",
    name: "Employer contact",
    number: "Employer phone numbers",
  },
};

export const livingSituationOptions = [
  {
    label: "Renting",
    value: "renter",
  },
  {
    label: "Mortgage",
    value: "buyer",
  },
  {
    label: "Own Home Outright - No Mortgage",
    value: "owner",
  },
  {
    label: "Boarding",
    value: "boarder",
  },
  {
    label: "Living with Parents",
    value: "living-with-parents",
  },
  {
    label: "Employer Provides Accommodation",
    value: "employer",
  },
];
